import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './CampaignQuestionContainer.module.less';
import QuestionPreview from './QuestionPreview';
import FullQuestion from './FullQuestion';

const CampaignQuestionContainer = ({
  qid,
}) => {
  return (
    <section className={styles.vpQuestionContainer}>
      <section
        className={styles.vpQuestionPanel}
      >
        <FullQuestion qid={qid} />
        <QuestionPreview qid={qid} />
      </section>
    </section>
  );
};

CampaignQuestionContainer.propTypes = {
  qid: PropTypes.string,
};

export default CampaignQuestionContainer;



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/CampaignQuestionContainer.jsx